import { render, staticRenderFns } from "./ag-checkbox.vue?vue&type=template&id=25237089"
import script from "./ag-checkbox.vue?vue&type=script&lang=js"
export * from "./ag-checkbox.vue?vue&type=script&lang=js"
import style0 from "./ag-checkbox.vue?vue&type=style&index=0&id=25237089&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports